import { ResponseModel, handleGetAsync, handleDeleteAsync, handlePostFormDataAsync, handlePutFormDataAsync } from "../../components/common/commonclass";
import { EndPoint } from "../../components/common/config";
import { handleNotify, TOASTER_POSITION, TOASTER_TYPE } from "../../components/common/notification/toaster_notify.component";

var responseModel = new ResponseModel();

export class ItemsService {
    static async getAllItems(storeId = null) {
        responseModel = new ResponseModel();
        const requestURL = EndPoint.ITEMS; //endpoint
        const requestModel = { storeId };

        responseModel = await handleGetAsync(requestURL, true, requestModel);
        if (responseModel) {
            return responseModel;
        }
        else {
            console.error('Failed to fetch Items.');
            return [];
        }
    }

    // Create
    // static async addNewItems(data) {
    //     responseModel = new ResponseModel();
    //     const requestURL = EndPoint.ITEMS; // endpoint
    //     responseModel = await handlePostAsync(requestURL, true, data);

    //     if (responseModel) {
    //         handleNotify('Items added successfully!', TOASTER_TYPE.SUCCESS, TOASTER_POSITION.TOP_RIGHT);
    //         return responseModel;
    //     } else {
    //         throw new Error('Failed to create new Items.');
    //     }
    // }

    static async addNewItems(values) {
        responseModel = new ResponseModel();
        const requestURL = EndPoint.ITEMS; // endpoint
        const data = new FormData();
        data.append('itemName', values.itemName);
        data.append('price', values.price);
        data.append('itemCode', values.itemCode);
        data.append('HSN_SACCode', values.HSN_SACCode);
        data.append('searchKeyword', values.searchKeyword);
        data.append('isActive', values.isActive);
        data.append('intraStateTaxGroupId', values.intraStateTaxGroupId);
        data.append('interStateTaxGroupId', values.interStateTaxGroupId);
        //data.append('intraStateTaxGroupName', values.intraStateTaxGroupName);
        //data.append('interStateTaxGroupName', values.interStateTaxGroupName);
        data.append('itemDescription', values.itemDescription);
        data.append('termsAndCondition', values.termsAndCondition);
        data.append('itemtype', values.itemtype);
        data.append('childType', values.childType);
        data.append('subchild', values.subchild);
        data.append('parentItemsId', values.parentItemsId);
        data.append('categoryId', values.categoryId);
        data.append('itemImage', values.itemImage);
        data.append('itemImageFileName', values.itemImageFileName);


        responseModel = await handlePostFormDataAsync(requestURL, true, data);

        if (responseModel) {
            handleNotify('Items added successfully!', TOASTER_TYPE.SUCCESS, TOASTER_POSITION.TOP_RIGHT);
            return responseModel;
        } else {
            throw new Error('Failed to create new Items.');
        }
    }

    // Get by ID
    static async getItemsById(id) {
        responseModel = new ResponseModel();
        const requestURL = `${EndPoint.ITEMS}/${id}`; // endpoint

        responseModel = await handleGetAsync(requestURL, true);
        if (responseModel) {
            return responseModel;
        } else {
            throw new Error('Failed to fetch Items by ID');
        }
    }

    // Update 
    static async updateItemsById(id, values) {
        responseModel = new ResponseModel();
        const requestURL = `${EndPoint.ITEMS}/${id}`; // endpoint
        const data = new FormData();

        // Append all required fields to FormData
        data.append('itemName', values.itemName);
        data.append('price', values.price);
        data.append('itemCode', values.itemCode);
        data.append('HSN_SACCode', values.HSN_SACCode);
        data.append('searchKeyword', values.searchKeyword);
        data.append('isActive', values.isActive);
        data.append('intraStateTaxGroupId', values.intraStateTaxGroupId);
        data.append('interStateTaxGroupId', values.interStateTaxGroupId);
        data.append('itemDescription', values.itemDescription);
        data.append('termsAndCondition', values.termsAndCondition);
        data.append('itemtype', values.itemtype);
        data.append('childType', values.childType);
        data.append('subchild', values.subchild);
        data.append('parentItemsId', values.parentItemsId);
        data.append('categoryId', values.categoryId);

        // Only append itemImage and itemImageFileName if new image is provided
        if (values.itemImage) {
            data.append('itemImage', values.itemImage);
        }
        if (values.itemImageFileName) {
            data.append('itemImageFileName', values.itemImageFileName);
        }

        responseModel = await handlePutFormDataAsync(requestURL, true, data);
        if (responseModel) {
            handleNotify('Items updated successfully.', TOASTER_TYPE.SUCCESS, TOASTER_POSITION.TOP_RIGHT);
            return responseModel;
        } else {
            throw new Error('Failed to update Items.');
        }
    }

    // static async updateItemsById(id, data) {
    //     responseModel = new ResponseModel();
    //     const requestURL = `${EndPoint.ITEMS}/${id}`; // endpoint

    //     responseModel = await handlePutFormDataAsync(requestURL, true, data);
    //     if (responseModel) {
    //         handleNotify('Items updated successfully.', TOASTER_TYPE.SUCCESS, TOASTER_POSITION.TOP_RIGHT);
    //         return responseModel;
    //     } else {
    //         throw new Error('Failed to update Items.');
    //     }
    // }

    // Delete 

    static async deleteItemById(id) {
        responseModel = new ResponseModel();
        const requestURL = `${EndPoint.ITEMS}/${id}`; // endpoint

        try {
            responseModel = await handleDeleteAsync(requestURL, true);
            if (responseModel) {
                return responseModel;
            } else {
                throw new Error('Failed to delete Items data.');
            }
        } catch (error) {
            console.error('Error deleting Items data:', error);
            throw error;
        }
    }

    // Delete  by IDs
    static async deleteManyItems(ids) {
        responseModel = new ResponseModel();
        const requestURL = `${EndPoint.ITEMS}/deletemany`; // endpoint

        responseModel = await handleDeleteAsync(requestURL, true, ids);
        if (responseModel) {
            handleNotify(responseModel, TOASTER_TYPE.SUCCESS, TOASTER_POSITION.TOP_RIGHT);
            return responseModel;
        } else {
            handleNotify(responseModel.error, TOASTER_TYPE.ERROR, TOASTER_POSITION.TOP_RIGHT);
        }
    }

    //get item by categoryId
    static async getItemsByCategoryId(categoryId) {
        responseModel = new ResponseModel();
        const requestURL = `${EndPoint.ITEMS}/basedOnCategoryId/${categoryId}`;
        //const requestModel = { categoryId };

        responseModel = await handleGetAsync(requestURL, true);
        if (responseModel) {
            return responseModel;
        }
        else {
            handleNotify(responseModel.error, TOASTER_TYPE.ERROR, TOASTER_POSITION.TOP_RIGHT); console.error()
        }
    }

    static async getStandardItemByMainItemId(id) {
        responseModel = new ResponseModel();
        const requestURL = `${EndPoint.ITEMS}/standard-sub-items/${id}`;

        responseModel = await handleGetAsync(requestURL, true);
        if (responseModel) {
            return responseModel;
        }
        else {
            handleNotify(responseModel.error, TOASTER_TYPE.ERROR, TOASTER_POSITION.TOP_RIGHT); console.error()
        }
    }

    static async getOptionalItemByMainItemId(id) {
        responseModel = new ResponseModel();
        const requestURL = `${EndPoint.ITEMS}/optional-sub-items/${id}`;

        responseModel = await handleGetAsync(requestURL, true);
        if (responseModel) {
            return responseModel;
        }
        else {
            handleNotify(responseModel.error, TOASTER_TYPE.ERROR, TOASTER_POSITION.TOP_RIGHT); console.error()
        }
    }
}
